import { Bot } from "lucide-react";
import React from "react";

export default function NoData({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="h-full flex flex-col items-center justify-center py-16 px-4">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
        <Bot className="w-8 h-8 text-indigo-500" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1">
        {title ?? "No Data Found"}
      </h3>
      <p className="text-sm text-gray-500">
        {description ?? "There are currently no data available."}
      </p>
    </div>
  );
}
